module.exports = __webpack_public_path__ + "img/centimeter.bb33b7ad.png";